/* Strive: small behaviour tweaks on top of Concept. Loaded with defer from layout/theme.liquid. */

/* The floating "Join the list" tab sits over the footer columns on desktop.
 * The footer has its own signup form, so hide the tab while the footer is on screen. */
(() => {
  const bar = document.querySelector('.newsletter-bar');
  const footer = document.querySelector('.footer')?.closest('.shopify-section');
  if (!bar || !footer || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(([entry]) => {
    bar.classList.toggle('strive-hidden', entry.isIntersecting);
  }, { rootMargin: '0px 0px -120px 0px' }).observe(footer);
})();


/* Hero model cards: fade each 3D model in once it has loaded. */
document.querySelectorAll('.strive-hero-model__3d').forEach((viewer) => {
  if (viewer.loaded) viewer.classList.add('strive-loaded');
  viewer.addEventListener('load', () => viewer.classList.add('strive-loaded'), { once: true });
});


/* Cookie banner: remember the visitor's Accept / Decline in this browser, so the
 * banner doesn't come back on every page when Shopify's consent record isn't
 * available (the local preview, blocked cookies). The same choice is passed to
 * Shopify's Customer Privacy API whenever it can be loaded. */
(() => {
  const KEY = 'strive-cookie-choice';
  const read = () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } };
  const save = (value) => { try { localStorage.setItem(KEY, value); } catch (e) {} };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('cookie-banner button[name="accept"], cookie-banner button[name="decline"]');
    if (button) save(button.name);
  });

  const choice = read();
  if (!choice) return;

  document.querySelectorAll('cookie-banner').forEach((banner) => banner.remove());

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{
      name: 'consent-tracking-api',
      version: '0.1',
      onLoad: () => {
        const privacy = window.Shopify.customerPrivacy;
        if (privacy && privacy.getTrackingConsent() === 'no_interaction') {
          privacy.setTrackingConsent(choice === 'accept', () => {});
        }
      }
    }]);
  }
})();


/* Links to the "Which Sutori is for you?" page scroll to the comparison instead
 * when it is on the same page (the homepage), so visitors don't leave to see a
 * table that is already below them. Without JS the link still opens the page. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href*="/pages/which-sutori"]');
  if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
  const target = document.querySelector('.strive-scissor-comparison');
  if (!target) return;
  event.preventDefault();
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
});


/* Mobile menu (snippets/strive-mnav.liquid): when the drawer opens, the scissor
 * cards rise in one after another, then the Accessories / Tools / All products
 * rows slide in, on the theme's own drawer easing. The theme only animates the
 * whole Shop block as one item. Skipped when the visitor prefers reduced motion. */
(() => {
  const EASE = [0.075, 0.82, 0.165, 1];
  const calm = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const play = (drawer) => {
    const Motion = window.Motion;
    const nav = drawer.querySelector('.strive-mnav');
    if (!nav || !Motion || calm()) return;
    const cards = [...nav.querySelectorAll('.strive-mnav__cards > li')];
    const media = cards.map((card) => card.querySelector('.strive-mnav__media img')).filter(Boolean);
    const rows = [...nav.querySelectorAll('.strive-mnav__rows > li')];
    const head = nav.querySelector('.strive-mnav__head');
    const all = [head, ...cards, ...rows].filter(Boolean);

    all.forEach((el) => { el.style.opacity = '0'; });
    nav.querySelector('.strive-mnav__cards')?.scrollTo({ left: 0 });

    // The theme starts its own item animation 300 ms after opening; start with it.
    setTimeout(() => {
      if (head) Motion.animate(head, { opacity: [0, 1], transform: ['translateY(0.75rem)', 'translateY(0)'] }, { duration: 0.6, easing: EASE });
      Motion.animate(cards, { opacity: [0, 1], transform: ['translateY(1.5rem)', 'translateY(0)'] }, { duration: 0.8, easing: EASE, delay: Motion.stagger(0.08, { start: 0.08 }) });
      if (media.length) Motion.animate(media, { transform: ['scale(1.12)', 'scale(1)'] }, { duration: 1.2, easing: EASE, delay: Motion.stagger(0.08, { start: 0.08 }) });
      Motion.animate(rows, { opacity: [0, 1], transform: ['translateX(-1.25rem)', 'translateX(0)'] }, { duration: 0.6, easing: EASE, delay: Motion.stagger(0.07, { start: 0.3 }) })
        .finished.then(() => [...all, ...media].forEach((el) => el.removeAttribute('style')));
    }, 300);
  };

  new MutationObserver((mutations) => {
    mutations.forEach(({ target }) => {
      if (target.id === 'MenuDrawer' && target.hasAttribute('open')) play(target);
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
})();


/* "In the chair" feed: let mouse users drag the carousel. Touch already swipes natively.
 * Snapping is paused while dragging, then the carousel glides to the nearest card. */
document.querySelectorAll('.shop-the-feed.slider').forEach((slider) => {
  if (!window.matchMedia('(pointer: fine)').matches) return;
  let startX = 0, startLeft = 0, lastX = 0, lastT = 0, velocity = 0, dragging = false, moved = false, settleTimer;

  const scrollable = () => slider.scrollWidth > slider.clientWidth + 1;
  const toggleCursor = () => slider.classList.toggle('strive-draggable', scrollable());
  toggleCursor();
  window.addEventListener('resize', toggleCursor);

  slider.addEventListener('dragstart', (event) => event.preventDefault());

  slider.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0 || !scrollable()) return;
    clearTimeout(settleTimer);
    slider.classList.remove('strive-settling');
    startX = lastX = event.clientX; lastT = event.timeStamp;
    startLeft = slider.scrollLeft; velocity = 0; dragging = true; moved = false;
  });

  window.addEventListener('pointermove', (event) => {
    if (!dragging) return;
    const dx = event.clientX - startX;
    if (!moved && Math.abs(dx) < 6) return;
    if (!moved) { moved = true; slider.classList.add('strive-dragging', 'strive-settling'); }
    const dt = event.timeStamp - lastT;
    if (dt > 0) velocity = 0.8 * ((event.clientX - lastX) / dt) + 0.2 * velocity;
    lastX = event.clientX; lastT = event.timeStamp;
    slider.scrollLeft = startLeft - dx;
  });

  const end = () => {
    if (!dragging) return;
    dragging = false;
    if (!moved) return;
    slider.classList.remove('strive-dragging');

    // Glide to the nearest card, carried a little further by the release speed.
    const step = slider.itemOffset || slider.clientWidth;
    const max = slider.scrollWidth - slider.clientWidth;
    const projected = slider.scrollLeft - velocity * 250;
    let target = Math.round(projected / step) * step;
    const travelled = slider.scrollLeft - startLeft;
    if (Math.round(target) === Math.round(startLeft) && Math.abs(travelled) > step * 0.15) target = startLeft + Math.sign(travelled) * step;
    target = Math.max(0, Math.min(max, target));
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    slider.scrollTo({ left: target, behavior: calm ? 'auto' : 'smooth' });
    settleTimer = setTimeout(() => slider.classList.remove('strive-settling'), calm ? 50 : 700);
  };
  window.addEventListener('pointerup', end);
  window.addEventListener('pointercancel', end);

  // A drag shouldn't count as a click on a card, button or link.
  slider.addEventListener('click', (event) => {
    if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; }
  }, true);
});
